import { RuntimeAction, SPI, ActionWidget, ActionWidgetProps } from '@kunlun/dependencies';

@SPI.ClassFactory(ActionWidget.Token({ name: 'setDefaultButton' }))
export class SetDefaultValue extends ActionWidget {
  public initialize(props: ActionWidgetProps<RuntimeAction>) {
    super.initialize(props);

    return this;
  }

  protected async clickAction(...args: unknown[]) {
    if (!(await this.validateConfirm())) {
      return false;
    }
    this.dataSource!.forEach((d) => {
      d.isDefault = false;
    });
    this.activeRecords![0].isDefault = true;
  }
}
